<template>
  <div class="time-picker">
    <input
      class="time-picker__input"
      type="text"
      :value="setValue()"
      readonly
      placeholder="시간선택"
      @click="visible = true"
    />
    <div class="time-picker__popover" v-if="visible">
      <div class="time-picker__list-wrap">
        <div class="time-picker__list time-picker__list--hour">
          <div
            v-for="hour in hour"
            :key="hour"
            class="time-picker__time"
            :class="{ 'time-picker__time--selected': selectedHour === hour }"
            @click="changeHour(hour)"
          >
            {{ hour }}시
          </div>
        </div>
        <div class="time-picker__list time-picker__list--minute">
          <div
            v-for="(minute, idx) in minute"
            :key="idx"
            class="time-picker__time"
            :class="{
              'time-picker__time--selected': selectedMinute === minute,
            }"
            @click="changeMinute(minute)"
          >
            {{ minute }}분
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["value", "mintime", "hour", "minute"],
  data() {
    return {
      selectedTime: "",
      visible: false,
      selectedHour: null,
      selectedMinute: null,
    };
  },
  watch: {},
  computed: {},
  methods: {
    setValue() {
      this.selectedHour = this.value.hour;
      this.selectedMinute = this.value.minute;

      if (this.selectedHour && this.selectedMinute) {
        return this.selectedHour + "시" + " " + this.selectedMinute + "분";
      }
    },
    changeHour(hour) {
      this.selectedHour = hour;
      this.value.hour = this.selectedHour;
      this.selectedMinute = null;
      this.value.minute = null;
    },
    changeMinute(minute) {
      this.selectedMinute = minute;
      this.value.minute = this.selectedMinute;
      this.setValue();
      this.visible = false;
    },
    updateData() {
      this.$emit("input", {
        hour: this.selectedHour,
        minute: this.selectedMinute,
      });
      this.$emit("update");
    },
  },

  mounted() {
    this.$emit("asap");
  },
};
</script>

<style scoped src="./layout.css"></style>
<style src="@/assets/css/newGlobal.css" scoped></style>
